import { TEXT } from 'texts';
import { checkCardNumber } from 'utils';

const MESSAGES = {
  CARD_NOT_VALID: TEXT.validationCardNotValid,
  REQUIRED: TEXT.validationRequired,
  EXPIRE_DATE: TEXT.validationExpireDateNotValid,
};

class Validator {
  compose = (validators?: Array<Function>) => (value: unknown): string | null => {
    if (validators) {
      return validators.reduce((error, validator) => error || validator(value), null);
    }
    return null;
  };

  required = (message?: string) => (value: string | boolean) => (value ? null : message || MESSAGES.REQUIRED);

  exactLength = (length: number, message: string) => (value: string) => (value.length !== length ? message : null);

  cardNumber = (message?: string) => (value: string) =>
    checkCardNumber(value) ? null : message || MESSAGES.CARD_NOT_VALID;

  length = (length: number, message: string) => (value: string) => (value.length !== length ? message : null);

  expireDate = (message?: string) => (value: string) => {
    const month = Number(value.substring(0, 2));
    const year = Number(value.substring(value.length - 2, value.length));
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = Number(`${new Date().getFullYear()}`.substr(2, 2));
    if (currentYear > year) {
      return message || MESSAGES.EXPIRE_DATE;
    }
    if (currentYear === year) {
      if (currentMonth > month) {
        return message || MESSAGES.EXPIRE_DATE;
      }
    }
    return null;
  };

  min = (min: number, message: string) => (value: string) => {
    if (!isNaN(Number(min))) {
      return Number(value) < min ? message : null;
    }
    return null;
  };
  max = (max: number, message: string) => (value: string) => {
    if (!isNaN(Number(max))) {
      return Number(value) > max ? message : null;
    }
    return null;
  };
}

export const validate = new Validator();
